module.exports = __webpack_public_path__ + "static/media/eng-flag.016dd8e9.png";